import { useLayoutEffect, useCallback, RefObject } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { setShouldValidate } from '../store/sale.reducer'
import { selectShouldScroll } from '../store/sale.selectors'

export default function useScrollToFirstError(formEl: RefObject<any>) {
  const shouldScroll = useSelector(selectShouldScroll)
  const dispatch = useDispatch()

  function setValdationStatus(status: boolean) {
    dispatch(setShouldValidate(status))
  }

  const handleSubmit = useCallback(() => {
    const invalidEl = formEl.current.querySelector('.Mui-error.MuiOutlinedInput-root')
    if (invalidEl) {
      const nativeInput = invalidEl.querySelector('.MuiInputBase-input')
      nativeInput.focus()
      invalidEl.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
      setValdationStatus(false)
    }
  }, [formEl])

  useLayoutEffect(() => {
    if (shouldScroll) {
      handleSubmit()
    }
  }, [shouldScroll])

  return { setValdationStatus }
}
